'use strict'

/**
 * Project easy title 24
 * Created by hielo on 2018-06-25
 */

import e24Footer from './footer.vue'
import e24NavBar from './nav-bar.vue'
import appLink from './app-link.vue'

function components (Vue, options) {
	Vue.component('app-link', appLink)
	// Structure
	Vue.component('v-e24-footer', e24Footer)
	Vue.component('v-e24-nav-bar', e24NavBar)
}

export default components



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/components/index-site.js